import classNames from 'classnames';
import { Tag } from '@shared/common/types/tags';
import { Common } from '@shared/common/types/main';

interface ContentWraperProps extends Common {
  as?: Tag;
}

const ContentWraper = (props: ContentWraperProps) => {
  const { id, classes, children, as = Tag.Div } = props;
  const TagComponent = as;

  return (
    <TagComponent className={classNames('content-wrapper', classes)} id={id}>
      {children}
    </TagComponent>
  );
};

export default ContentWraper;
